// Service worker registration. Only runs in production builds — the dev
// server uses HMR and a SW would interfere with it.
//
// First-load cache priming: the SW's static precache list can't include the
// hashed JS/CSS bundles because their filenames aren't known until build time.
// Rather than parsing the build manifest, we ask the page what it just
// loaded and forward that list to the SW so it can fetch + cache those
// assets. This guarantees the next offline visit gets the full app shell.

export const registerServiceWorker = (): void => {
  if (!import.meta.env.PROD) return;
  if (!("serviceWorker" in navigator)) return;

  const url = `${import.meta.env.BASE_URL}sw.js`;
  const scope = import.meta.env.BASE_URL;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register(url, { scope })
      .then(async () => {
        const ready = await navigator.serviceWorker.ready;
        const active = ready.active;
        if (!active) return;
        const sameOrigin = (u: string): boolean => {
          try {
            return new URL(u).origin === location.origin;
          } catch {
            return false;
          }
        };
        const urls = performance
          .getEntriesByType("resource")
          .map((entry) => entry.name)
          .filter(sameOrigin);
        active.postMessage({ type: "cache-current", urls });
      })
      .catch((err) => {
        console.warn("[pwa] service worker registration failed:", err);
      });
  });
};
